const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the groups manager directive
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {Groups} Groups injected to gain access to the Groups resource
 */
app.directive('groupsManager', ['Application', 'Authorization', 'Groups', function (Application, Authorization, Groups) {
  return {
    restrict: "E",
    replace: true,
    scope : {},
    template: require('../../../templates/directives/groups/groups-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.profiles = [];

      self.createGroup = function() {
        Application.navigation.goTo('/edit/groups');
      };

      self.selectedForDelete = null;
      self.selectDelete = function(item) {
        self.selectedForDelete = item;
        self.showDelete = true
      };

      self.deleteSelected = function() {
        self.loading = true;

        Groups.remove({subresource: self.selectedForDelete}).$promise
        .then(function(results) {
          self.editMenu.closeHandler();
          self.loading = false;
          self.showDelete = false;
          self.paging.page = 1;
          self.paging.userCount = {};
          self.paging.map = {};
          self.paging.confirmedLast = null;
          self.getPage();
          Application.messaging.addMessage({type: 'success', text: 'Group Removed.', duration: 5});
        }).catch(function(error) {
          self.loading = false;
          Application.messaging.addMessage({type: 'error', text: 'There was an issue removing the group.', duration: 7});
        })
      };

      self.showUsers = function(group, type) {
        Application.navigation.goTo('/view/groups/' + group, {type: (type || 'users')});
      };

      self.assign = {
        selection: {},
        show: false,
        success: false,
        select: function(item) {
          self.assign.selection = item;
          self.assign.show = true;
        },
        edit: function(item) {
          Application.navigation.goTo('/edit/groups/' + item._id);
        },
        cancel: function() {
          self.assign.show = false;
          self.assign.selection = {};
          self.editMenu.closeHandler();
        },
        onComplete: function() {
          var selectedId = self.assign.selection._id;
          self.paging.getUserCounts(selectedId);
          self.assign.cancel();
        }
      };

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        }
      };

      self.paging = {
        page: 1,
        perPage: 10,
        userCount: {},
        map: {},
        confirmedLast: null,
        showUsers: false,
        showManagers: false,
        selectedUsers: null,
        selectedManagers: null,
        searchTerm: '',
        delayedSearch: null,
        selectForUsers: function(group) {
          self.paging.selectedUsers = group;
          self.paging.showUsers = true;
        },
        selectForManagers: function(group) {
          self.paging.selectedManagers = group;
          self.paging.showManagers = true;
        },
        next: function() {
          if (self.paging.confirmedLast && self.paging.page >= self.paging.confirmedLast) {
            return;
          }

          self.paging.page++;
          self.getPage();
        },
        previous: function() {
          if (self.paging.page <= 1) {
            return;
          }

          self.paging.page--;
          self.getPage();
        },
        getUserCounts: function(id) {
          var groups = id ? [{_id: id}] : self.groups;
          groups = groups.map(function(item) {
            return item._id;
          });

          Groups.getUserCounts({groups: groups.join(',')}).$promise
          .then(function(results) {
            results.forEach(function(result) {
              var group = result.group;
              self.paging.userCount[group] = result;
            });
          }).catch(function(error) {
            console.log('error in group get user counts: ', error);
          });
        }
      };

      self.getPage = function(ignore) {
        if (self.paging.map[self.paging.page] && !ignore) {
          self.groups = self.paging.map[self.paging.page];
          return;
        }

        self.loading = true;
        var query = {
          fields: 'name,description,user,createdAt',
          'user-populate': 'first_name,last_name,full_name,email',
          page: self.paging.page,
          per_page: self.paging.perPage
        };

        if (self.paging.searchTerm) {
          query.name = '$regex,2,' + self.paging.searchTerm + ',i';
        }

        Groups.find(query).$promise
        .then(function(groups) {
          if (!groups || !groups.length) {
            self.paging.confirmedLast = self.paging.page - 1;
            self.paging.page--;
            self.loading = false;
            return;
          }

          if (groups.length < self.paging.perPage && !ignore) {
            self.paging.confirmedLast = self.paging.page;
          }

          if (!ignore) {
            self.paging.map[self.paging.page] = groups;
          }

          self.groups = groups || [];
          self.paging.getUserCounts();
          self.loading = false;
        }).catch(function(err) {
          console.log(err);
          Application.messaging.addMessage({type: 'error', text: 'Error in getting access groups.', duration: 5});

          self.loading = false;
        });
      };

      $scope.$watch('groups.paging.searchTerm', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (self.paging.delayedSearch) {
            clearTimeout(self.paging.delayedSearch);
          }

          self.paging.delayedSearch = setTimeout(function() {
            self.paging.delayedSearch = null;
            self.paging.page = 1;
            self.getPage(true);
          }, 500);
        }
      });

      self.initialize = function() {
        if (!self.user || !self.user.role || self.user.role !== 'admin') {
          Application.navigation.back();
          return;
        }

        self.getPage();
      };

      self.initialize();

    }],
    controllerAs: 'groups'
  };
}]);